import React, { useEffect, useState } from "react";
import { trackMetaPixelRegistration } from "../utils/metaPixel";
import { useDispatch, useSelector } from "react-redux";
import {
  getBotAccessList,
  registerStudent,
} from "../features/student/redux/studentThunk";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { studentClasses } from "../configs/WebService";
import axios from "axios";
import LoaderOverlay from "./LoaderOverlay";
import { clearGoogleAndMobile } from "../features/QuestionPaper/createpaper/components/registration/redux/registerSlice";

export default function StudentRegistrationForm({ stopAudio }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, botAccess } = useSelector((state) => state.student);
  const { googleEmail, mobile, adminName } = useSelector(
    (state) => state.register,
  );
  const [searchParams] = useSearchParams();

  const [classes, setClasses] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    className: "",
    email: googleEmail || "",
    contactNumber: mobile || "",
    password: "",
    confirmPassword: "",
    schoolName: "",
    schoolContact: "",
    referralCode: "",
  });
  useEffect(() => {
    axios
      .get(`${studentClasses}`)
      .then((res) => {
        if (res.data.success) {
          setClasses(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching classes:", err);
      });
  }, []);
  useEffect(() => {
    const refCode = searchParams.get("ref");

    if (refCode && /^[a-zA-Z0-9]{8}$/.test(refCode)) {
      setFormData((prev) => ({
        ...prev,
        referralCode: refCode,
      }));
    }
  }, [searchParams]);

  useEffect(() => {
    if (googleEmail) {
      setFormData((prev) => ({
        ...prev,
        email: googleEmail,
      }));
    }
    if (adminName) {
      setFormData((prev) => ({ ...prev, name: adminName }));
    }
    if (mobile) {
      setFormData((prev) => ({
        ...prev,
        contactNumber: mobile,
      }));
    }
  }, [googleEmail, mobile, adminName]);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { state } = useLocation();
  // const registerType = state?.register_type;
  const registerType = state?.register_type
    ? state?.register_type
    : "direct_signup_page";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    dispatch(getBotAccessList());
  }, [dispatch]);

  const [errors, setErrors] = useState({
    contactNumber: "",
    schoolContact: "",
  });

  const handlePhoneInput = (e) => {
    const { name, value } = e.target;

    if (/^\d*$/.test(value)) {
      setFormData({ ...formData, [name]: value });

      if (value.length !== 10) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Phone number must be exactly 10 digits",
        }));
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (stopAudio) stopAudio();
    if (formData.contactNumber.length !== 10) {
      setErrors((prev) => ({
        ...prev,
        contactNumber: "Phone number must be exactly 10 digits",
      }));
      return;
    }

    if (formData.schoolContact.length !== 10) {
      setErrors((prev) => ({
        ...prev,
        schoolContact: "School contact must be exactly 10 digits",
      }));
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    const payload = {
      username: formData.name,
      email: formData.email,
      password: formData.password,
      school_name: formData.schoolName,
      contact_number: formData.contactNumber,
      address: "",
      school_type: "",
      db_name: "",
      port: 5010,
      account_type: "student",
      parent_id: "",
      dob: null,
      studentClass: formData.className,
      section: null,
      rollNumber: null,
      registrationDate: new Date().toISOString().split("T")[0],
      school_contact: formData.schoolContact,
      registerType: registerType,
      referral_code: formData.referralCode || null,
    };

    // dispatch(registerStudent(payload)).unwrap();
    // navigate("/login");
    dispatch(registerStudent(payload))
      .unwrap()
      .then((res) => {
        console.log("✅ Registration success:", res);
        trackMetaPixelRegistration();
        // alert("✅ Registration success");
        alert(
          "OTP has been sent to your email. Please verify to complete registration.",
        );
        dispatch(clearGoogleAndMobile());
        navigate("/otp", {
          state: {
            formData: payload,
            isWhatsapp: botAccess?.isWhatsapp,
            isEmailSuccessful: botAccess?.isEmailSuccessful,
            isSMS: botAccess?.isSMS,
          },
        });
        //navigate("/login");
      })
      .catch((err) => {
        console.error("❌ Registration failed:", err);
        alert("❌ Registration failed:" + err);
      });
  };

  return (
    <div style={{ position: "relative" }}>
      {loading && <LoaderOverlay />}
      <form
        onSubmit={handleSubmit}
        animate={{ opacity: loading ? 0.4 : 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="mb-2">
          <input
            type="text"
            name="name"
            placeholder="Name of Student"
            required
            value={formData.name}
            onChange={handleChange}
            disabled={!!adminName}
            className="form-control"
          />
        </div>
        <div className="mb-2">
          <select
            name="className"
            required
            value={formData.className}
            onChange={handleChange}
            className="form-control"
          >
            <option value="">Select Class</option>
            {classes.map((cls) => (
              <option key={cls.class_id} value={cls.class_id}>
                {cls.class_name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-2">
          <input
            type="email"
            name="email"
            placeholder="Email ID"
            required
            value={formData.email}
            disabled={!!googleEmail}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="mb-2">
          <input
            type="text"
            name="contactNumber"
            placeholder="Contact Number"
            maxLength={10}
            value={formData.contactNumber}
            onChange={handlePhoneInput}
            disabled={!!mobile}
            className="form-control"
            required
          />
        </div>
        {errors.contactNumber && (
          <small style={{ color: "red", fontSize: "12px" }}>
            {errors.contactNumber}
          </small>
        )}
        <div className="mb-2 position-relative">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            required
            value={formData.password}
            onChange={handleChange}
            className="form-control"
            style={{ paddingRight: "40px" }}
          />
          <i
            className={`fa-solid ${
              showPassword ? "fa-eye-slash" : "fa-eye"
            } position-absolute`}
            style={{
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
            onClick={() => setShowPassword(!showPassword)}
          ></i>
        </div>
        <div className="mb-2 position-relative">
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            placeholder="Confirm Password"
            required
            value={formData.confirmPassword}
            onChange={handleChange}
            className="form-control"
          />
          <i
            className={`fa-solid ${
              showConfirmPassword ? "fa-eye-slash" : "fa-eye"
            } position-absolute`}
            style={{
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          ></i>
        </div>
        <div className="mb-2">
          <input
            type="text"
            name="schoolName"
            placeholder="Name of the School Studying in"
            required
            value={formData.schoolName}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="mb-3">
          <input
            type="text"
            name="schoolContact"
            placeholder="School Contact Number"
            maxLength={10}
            value={formData.schoolContact}
            onChange={handlePhoneInput}
            className="form-control"
            required
          />
          {errors.schoolContact && (
            <small style={{ color: "red", fontSize: "12px" }}>
              {errors.schoolContact}
            </small>
          )}
        </div>
        <div className="mb-2">
          <input
            type="text"
            name="referralCode"
            placeholder="Referral Code (Optional)"
            value={formData.referralCode}
            maxLength={8}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z0-9]*$/.test(value)) {
                setFormData({ ...formData, referralCode: value });
              }
            }}
            className="form-control"
          />
          {formData.referralCode &&
            !/^[a-zA-Z0-9]{8}$/.test(formData.referralCode) && (
              <small style={{ color: "red", fontSize: "12px" }}>
                Referral code must be exactly 8 alphanumeric characters
              </small>
            )}
        </div>

        <button type="submit" className="btn btn-primary w-100">
          Register
        </button>
      </form>
    </div>
  );
}
